import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SignOutIcon = ({ size = 14, color = '#FE5851', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    viewBox="0 0 14 14"
    {...props}
  >
    <path
      fill={color}
      d="M13.224 0a.742.742 0 0 1 .423.124.713.713 0 0 1 .126.1c.119.119.198.274.226.443a.664.664 0 0 1-.007.143v11.503a.713.713 0 0 0 0 .074.276.276 0 0 1-.022.073.34.34 0 0 1-.026.073l-.042.077a.252.252 0 0 1-.032.057.413.413 0 0 1-.058.08l-.04.046-.07.057a.269.269 0 0 1-.052.04l-.026.02-4.988 2.98a.756.756 0 0 1-.788 0 .815.815 0 0 1-.397-.703V13.02h-3.5a.8.8 0 0 1-.788-.813V10.93c0-.29.15-.559.393-.704a.766.766 0 0 1 .788 0 .819.819 0 0 1 .393.704v.46h2.714V4.333a.828.828 0 0 1 .342-.666l2.882-2.037H4.747v.457a.8.8 0 0 1-.787.813.8.8 0 0 1-.788-.813V.814A.8.8 0 0 1 3.96 0ZM1.646 4.73a.776.776 0 0 1 1.117-.063c.31.3.335.798.058 1.13l-.284.333h3.55c.415.028.74.384.74.815 0 .43-.325.788-.74.815h-3.55l.293.32c.207.24.259.583.132.876a.79.79 0 0 1-.719.484.792.792 0 0 1-.587-.27L.19 7.487a.12.12 0 0 1-.023-.034L.113 7.38l-.035-.067A.562.562 0 0 1 .02 7.16l-.016-.063a.86.86 0 0 1 0-.157.826.826 0 0 1 0-.153v-.044c.012-.046.032-.076.032-.103a.339.339 0 0 1 .022-.05l.046-.087.038-.053.04-.053Z"
    />
  </svg>
);

SignOutIcon.propTypes = propTypes;

export default SignOutIcon;
